import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45c814ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "questionsView" }
const _hoisted_2 = { class: "stat-cell" }
const _hoisted_3 = { class: "stat-text" }

import { onMounted, ref } from "vue";
import {
  Question,
  QuestionControllerService,
  QuestionQueryRequest,
} from "../../../generated";
import message from "@arco-design/web-vue/es/message";
import { useRouter } from "vue-router";
import moment from "moment";


export default /*#__PURE__*/_defineComponent({
  __name: 'QuestionsView',
  setup(__props) {

const router = useRouter();

const dataList = ref<Question[]>([]);
const total = ref(0);
const searchParams = ref<QuestionQueryRequest>({
  title: "",
  tags: [],
  pageSize: 15,
  current: 1,
});

const loadData = async () => {
  const res = await QuestionControllerService.listQuestionVoByPageUsingPost(
    searchParams.value
  );
  if (res.code === 0) {
    dataList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error("加载失败，" + res.message);
  }
};

onMounted(() => {
  loadData();
});

const columns = [
  { title: "题号", dataIndex: "id", width: 70 },
  { title: "题目名称", slotName: "title", ellipsis: true },
  { title: "标签", slotName: "tags", width: 200 },
  { title: "通过率", slotName: "acceptedRate", width: 150 },
  { title: "创建时间", slotName: "createTime", width: 120 },
  { title: "操作", slotName: "optional", width: 80, align: "center" },
];

const onPageChange = (page: number) => {
  searchParams.value = { ...searchParams.value, current: page };
};

const toQuestionPage = (question: Question) => {
  router.push({ path: `/view/question/${question.id}` });
};

const doSubmit = () => {
  searchParams.value = { ...searchParams.value, current: 1 };
  loadData();
};

const getRateColor = (record: Question) => {
  if (!record.submitNum) return "#86909c";
  const rate = record.acceptedNum / record.submitNum;
  if (rate >= 0.6) return "#00b42a";
  if (rate >= 0.3) return "#ff7d00";
  return "#f53f3f";
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_tag = _resolveComponent("a-input-tag")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_link = _resolveComponent("a-link")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_progress = _resolveComponent("a-progress")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, {
      title: "题目列表",
      bordered: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: searchParams.value,
          layout: "inline",
          style: {"margin-bottom":"16px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              field: "title",
              label: "名称"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  modelValue: searchParams.value.title,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchParams.value.title) = $event)),
                  placeholder: "搜索题目名称",
                  "allow-clear": "",
                  onPressEnter: doSubmit
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              field: "tags",
              label: "标签"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_tag, {
                  modelValue: searchParams.value.tags,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchParams.value.tags) = $event)),
                  placeholder: "输入标签",
                  style: {"width":"200px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: doSubmit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("搜索")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createVNode(_component_a_table, {
          columns: columns,
          data: dataList.value,
          pagination: {
          showTotal: true,
          pageSize: searchParams.value.pageSize,
          current: searchParams.value.current,
          total: total.value,
        },
          onPageChange: onPageChange,
          "row-key": "id"
        }, {
          title: _withCtx(({ record }) => [
            _createVNode(_component_a_link, {
              onClick: ($event: any) => (_unref(router).push(`/view/question/${record.id}`))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(record.title), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          tags: _withCtx(({ record }) => [
            _createVNode(_component_a_space, { wrap: "" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.tags, (tag, index) => {
                  return (_openBlock(), _createBlock(_component_a_tag, {
                    key: index,
                    color: "cyan",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tag), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 2
            }, 1024)
          ]),
          acceptedRate: _withCtx(({ record }) => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_a_progress, {
                percent: 
                record.submitNum ? record.acceptedNum / record.submitNum : 0
              ,
                "show-text": false,
                size: "small",
                color: getRateColor(record),
                style: {"width":"60px","display":"inline-block","vertical-align":"middle"}
              }, null, 8, ["percent", "color"]),
              _createElementVNode("span", _hoisted_3, _toDisplayString(record.acceptedNum || 0) + "/" + _toDisplayString(record.submitNum || 0), 1)
            ])
          ]),
          createTime: _withCtx(({ record }) => [
            _createTextVNode(_toDisplayString(_unref(moment)(record.createTime).format("YYYY-MM-DD")), 1)
          ]),
          optional: _withCtx(({ record }) => [
            _createVNode(_component_a_button, {
              type: "primary",
              size: "small",
              onClick: ($event: any) => (toQuestionPage(record))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 做题 ")
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }, 8, ["data", "pagination"])
      ]),
      _: 1
    })
  ]))
}
}

})